import React, { useState, useEffect, useRef } from 'react'
import { SourcingAuctionBuyerStyle } from './styled'

// Core
import { ENV_CONFIG } from '../../core/config'

// Helpers
import { localStorageService, dateUTCToObj, ROUTE_PATH } from '../../helpers'

// Socket Component
import { Loading, Section } from '../../components'
import { SIOSocket } from '../../components/socket/SIOSocket'
import { SIOEvent } from '../../components/socket/SIOEvent'

// Element
import Title from './element/Title'
import ButtonBack from './element/ButtonBack'
import AuctionInformation from './element/AuctionInformation'
import TimeLeftBid from './element/TimeLeftBid'
import BidTable from './element/BidTable'
import ModalHistoryOfSupplier from './element/ModalHistoryOfSupplier'
import ModalTimeOut from './element/ModalTimeOut'

// Service
import auctionService from '../../apiService/services/auctionService'
import { SIOBidding } from '../../components/socket/SIOBidding'

// Store
import usePrevious from './func/usePrevious'
import { store } from '../../store'
import { toast } from 'react-toastify'
import { generatePath } from 'react-router'

const SourcingAuctionBuyerContainer = props => {
  const { match } = props
  const { params } = match
  const sourcingID = params ? params.sourcingid : ''
  const isMounted = useRef(false)
  const [modals, setModals] = useState([
    { name: 'modals-history-of-supplier', isOpen: false },
  ])
  const [eventData, setEventData] = useState({})
  const [supplierOnline, setSupplierOnline] = useState([])
  const [supplierSoc, setSupplierSoc] = useState({})
  const [supplierRankingList, setSupplierRankingList] = useState([])
  const [supplierBidHistory, setSupplierBidHistory] = useState([])
  const [itemBidHistory, setItemBidHistory] = useState([])
  const [itemBidClick, setItemBidClick] = useState('')
  const [biddingStatus, setBiddingStatus] = useState('')
  const [leading, setLeading] = useState({
    userID: 0,
    price: 0,
  })
  const [isLoading, setIsLoading] = useState(false)

  const [loadingViewBid, setLoadingViewBid] = useState(false)
  const prevLeadingPrice = usePrevious(leading.price)
  const [timeLeft, setTimeLeft] = useState([])
  const { role } = store.getState()
  const apiRedirectPath = ROUTE_PATH.SOURCING_BUYER.LINK
  const timeOut = Array.isArray(timeLeft) && timeLeft.every(time => time === 0)
  const [redirectPathEvent, setRedirectPathEvent] = useState('')

  const syncInitialLeading = value => {
    if (!value || value.price === undefined || value.price === null) {
      return
    }

    setLeading(prevLeading => {
      if (prevLeading.price || prevLeading.userID) {
        return prevLeading
      }

      return {
        userID: value.userID || 0,
        price: value.price || 0,
      }
    })
  }

  useEffect(() => {
    setIsLoading(true)
    ;(async () => {
      isMounted.current = true
      await getEventList(sourcingID)
    })()
    setIsLoading(false)

    return () => {
      isMounted.current = false
    }
  }, [isMounted, prevLeadingPrice, leading, timeOut])

  useEffect(() => {
    if (supplierOnline && supplierOnline.length > 0) {
      checkOnlineSupList()
    }
  }, [supplierOnline.length, JSON.stringify(supplierRankingList)])

  useEffect(() => {
    if (supplierOnline && supplierOnline.length > 0) {
      checkOnlineSupCheck()
    }
  }, [supplierSoc, supplierSoc.user])

  useEffect(() => {
    ;(async () => {
      if (itemBidClick && eventData.event_no) {
        await getItemOfBidHistory(eventData.event_no, itemBidClick.supplier_id)
      }
    })()
  }, [itemBidClick, prevLeadingPrice, leading])

  const getEventList = async id => {
    const resAuction = await auctionService.getAuctionByID(id)
    const resDummy = await auctionService.getDummyListByID(id)
    const resSupplier = await auctionService.getSupplierListByID(id)

    const bidding_type = resAuction && resAuction.bidding_type

    let resRanking = {}
    let resBidHistory = []

    if (resAuction) {
      setEventData(resAuction)
      setRedirectPathEvent(
        generatePath(ROUTE_PATH.SOURCING_COMPARE_EVENT.LINK, {
          id: resAuction.sourcing_project_id,
          rfqid: resAuction.id,
          eventType: resAuction.event_type_id,
        })
      )
      resRanking = await auctionService.getRankingBidByEventId(
        resAuction.event_no
      )
      resBidHistory = await auctionService.getSupplierBidHistoryListByEventId(
        resAuction.event_no
      )
      if (!resRanking || Array.isArray(resRanking) || resRanking.status) {
        resRanking = {}
      }
      if (!Array.isArray(resBidHistory)) {
        resBidHistory = []
      }
    }

    const dataCheck = {
      is_dummy: resAuction && resAuction.display_dummy_supplier_name,
      is_str_date: resAuction && dateUTCToObj(resAuction.start_date),
      is_auc0: parseInt(resAuction && resAuction.id.split('')[0], 16), // แปลงฐาน 16
      is_auc1: parseInt(resAuction && resAuction.id.split('')[1], 16),
    }

    if (resDummy && resSupplier) {
      const dataRank = []
      resSupplier.forEach((item, i) => {
        if (item.response_status === 'Accepted') {
          const sup = checkDummy(
            item.supplier_id,
            resDummy,
            resSupplier,
            dataCheck
          )
          dataRank.push({
            ...item,
            company_name: sup.company,
            bid_no: checkRankingBid(resRanking, item).bid_no,
            bid_total: checkRankingBid(resRanking, item).bid_total,
            log_time: checkRankingBid(resRanking, item).log_time,
          })
        }
      })
      dataRank.sort(function (a, b) {
        if (bidding_type === 'Reverse') {
          if (a.bid_total === 0) return 1
          if (b.bid_total === 0) return -1
          return a.bid_total - b.bid_total
        } else {
          return b.bid_total - a.bid_total
        }
      })
      setSupplierRankingList(dataRank)
      syncInitialLeading({
        userID: dataRank[0] && dataRank[0].supplier_id,
        price: dataRank[0] && dataRank[0].bid_total,
      })
      checkOnlineSupList()
    }

    if (resBidHistory && resDummy) {
      const dataHis = resBidHistory.map((item, i) => {
        const dummy = checkDummy(item.user, resDummy, resSupplier, dataCheck)
        return {
          ...item,
          company_name: dummy.company,
          dummy_id: dummy.dummy_id,
        }
      })
      setSupplierBidHistory(dataHis)
    }
  }

  const checkDummy = (sup_id, dummyList, supplierList, check) => {
    if (dummyList) {
      let company = ''
      let dummy_id = ''
      dummyList.map((item, i) => {
        const sup_to_dummy =
          Number(sup_id) +
          (check.is_auc0 * 31 * 16 * 24 +
            check.is_str_date.day * 16 * 24 +
            check.is_auc1 * 24 +
            check.is_str_date.hour)

        if (item.dummy_id === sup_to_dummy.toString()) {
          if (check.is_dummy) {
            company = item.dummy_name
            dummy_id = item.dummy_id
          } else {
            company = checkCompanyName(supplierList, sup_id)
            dummy_id = item.dummy_id
          }
        }
      })
      return { company: company, dummy_id: dummy_id }
    }
  }

  const checkCompanyName = (list, supId) => {
    let company_name = ''
    if (list && list.length > 0) {
      list.map((item, i) => {
        if (item.supplier_id === Number(supId)) {
          company_name = item.company_name
        }
      })
    }
    return company_name
  }

  const checkRankingBid = (ranking, sup) => {
    let supData = { bid_no: 0, log_time: '', bid_total: 0 }
    for (let supId in ranking) {
      if (supId === sup.supplier_id.toString()) {
        supData = ranking[supId]
      }
    }
    return supData
  }

  const getItemOfBidHistory = async (eventId, userId) => {
    setLoadingViewBid(true)
    const newItem = await auctionService.getItemsBidHistoryOfSupplierByEventIdNUserId(
      eventId,
      userId
    )
    const oldItem = await auctionService.getAuctionItemByBuyerID(sourcingID)
    if (oldItem) {
      let item_suppliers = oldItem.map(item => {
        return {
          ...item,
          total_price: item.total_price ? item.total_price : 0,
          unit_price: item.unit_price ? item.unit_price : 0,
          auction_buyer_item_file: item.auction_buyer_item_file.map(j => ({
            id: j.id,
            name: j.name,
            is_delete: false,
          })),
        }
      })

      if (newItem) {
        for (let i = 0; i < newItem.length; i++) {
          newItem[i].items.map((val, j) => {
            item_suppliers.map(value => {
              if (value.id === val.id) {
                newItem[i].items[j] = {
                  ...newItem[i].items[j],
                  description: value.description,
                  uom: value.uom,
                  name: value.name,
                }
              }
            })
          })
        }
        setItemBidHistory(newItem)
        setLoadingViewBid(false)
      }
    }
  }

  const toggleModal = id => {
    if (isMounted.current) {
      const mapValue = modals.map(modal => ({
        ...modal,
        isOpen: modal.name === id ? !modal.isOpen : false,
      }))
      return setModals(mapValue)
    }
  }
  const SocRoom = data => {
    console.log('online', data) // connect successfully
    if (data) {
      if (data.user_list) {
        setSupplierOnline(data.user_list)
      } else if (data.user) {
        setSupplierSoc(data)
      }
    }
  }

  const checkOnlineSupCheck = () => {
    let supList = []
    supplierOnline.map((sup, s) => {
      if (sup === supplierSoc.user && supplierSoc.stat === 0) {
        supList = supplierOnline.splice(0, s)
      } else if (sup !== supplierSoc.user && supplierSoc.stat === 1) {
        supList = supplierOnline.concat([supplierSoc.user])
      }
    })
    setSupplierOnline([...supList])
  }

  const checkOnlineSupList = () => {
    if (supplierRankingList && supplierRankingList.length > 0) {
      const data = supplierRankingList.map((item, i) => {
        const checkId = supplierOnline.find(
          itemS => Number(itemS) === item.supplier_id
        )
        if (checkId) {
          return { ...item, status: 1 }
        } else {
          return { ...item, status: 0 }
        }
      })
      setSupplierRankingList(data)
    }
  }

  const onBiddingTime = data => {
    if (data) {
      if (data.price === 0 || data.price > 0) {
        setLeading({
          userID: data.leading,
          price: data.price ? data.price : 0,
        })
      } else {
        setTimeLeft(data)
      }
    }
  }

  const SocStatusBidding = data => {
    console.log('Status : ', data) // connect successfully
    if (data) {
      if (data === 'invalid time') {
        //go to another screen
        toast.error('Invalid Time')
        props.history.replace(apiRedirectPath)
      }
      if (data === 'close') {
        setBiddingStatus(data)
      }
    }
  }

  const SocOnDisconnected = reason => {
    if (reason === 'transport close') {
      toast.error('Please check internet connection and reload the page.', {
        delay: 6,
      })
    } else if (reason === 'io server disconnect') {
      toast.error('Disconnect', {
        delay: 6,
      })
    }
    props.history.replace(apiRedirectPath)
  }

  const handlersClose = () => {
    return toggleModal()
  }

  return (
    <React.Fragment>
      <Loading loading={isLoading} spinner={isLoading} />
      {eventData && (
        <SourcingAuctionBuyerStyle>
          <ButtonBack props={props} apiRedirectPath={apiRedirectPath} />
          <Section className="auction-wrapper">
            <Title />
            <AuctionInformation eventData={eventData} />
            {eventData.event_no && (
              <SIOSocket options={ENV_CONFIG.socketIO}>
                <SIOEvent
                  on="connect"
                  callback={SocRoom}
                  room={{
                    event: `auction_` + eventData.event_no,
                    userID: `B_${localStorageService.getBuyerId()}`,
                  }}
                  member={true}
                />
                <SIOEvent on="event-status" callback={SocStatusBidding} />
                <SIOEvent on="disconnect" callback={SocOnDisconnected} />
                <SIOBidding callback={onBiddingTime} />
                <TimeLeftBid timeLeft={timeLeft} />
                <BidTable
                  leading={leading}
                  supplierRankingList={supplierRankingList}
                  supplierBidHistory={supplierBidHistory}
                  currency={eventData.currency}
                  toggleModal={toggleModal}
                  setItemBidClick={data => setItemBidClick(data)}
                />
              </SIOSocket>
            )}
          </Section>
          {modals[0].isOpen && (
            <ModalHistoryOfSupplier
              modals={modals}
              toggleModal={toggleModal}
              itemBidHistory={itemBidHistory}
              eventData={eventData}
              itemBidClick={itemBidClick}
              role={role}
              handlersClose={handlersClose}
              loadingViewBid={loadingViewBid}
            />
          )}
          {/*check auction status is close and time out*/}
          {biddingStatus && (
            <ModalTimeOut
              timeOut={!!biddingStatus}
              props={props}
              handlersClose={handlersClose}
              apiRedirectPath={redirectPathEvent}
            />
          )}
        </SourcingAuctionBuyerStyle>
      )}
    </React.Fragment>
  )
}
export { SourcingAuctionBuyerContainer }

export default SourcingAuctionBuyerContainer
